import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AngleDownIcon } from 'prime-ng-old/icons/angledown';
import { AngleRightIcon } from 'prime-ng-old/icons/angleright';
import { BarsIcon } from 'prime-ng-old/icons/bars';
import { Menubar as MenubarBase, MenubarService, MenubarSub as MenubarSubBase } from 'prime-ng-old/menubar';
import { UiRouterLinkActivePathDirective } from '../router-link-active-path';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/router";
const _c0 = (a0, a1) => ({
  "p-submenu-list": a0,
  "p-menubar-root-list": a1
});
const _c1 = (a0, a1) => ({
  "p-menuitem-link": true,
  "p-disabled": a0,
  "ui-menuitem-active": a1
});
const _c2 = () => ({
  isActive: "p-menuitem-link-active"
});
const _c3 = a0 => ({
  "p-menuitem-link": true,
  "p-disabled": a0
});
const _c4 = a0 => ({
  $implicit: a0
});
function MenubarSub_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 5);
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r1.getItemProp(processedItem_r1, "style"));
    i0.ɵɵproperty("ngClass", ctx_r1.getSeparatorItemClass(processedItem_r1));
    i0.ɵɵattribute("id", ctx_r1.getItemId(processedItem_r1))("data-pc-section", "separator");
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 11);
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.getItemProp(processedItem_r1, "icon"))("ngStyle", ctx_r1.getItemProp(processedItem_r1, "iconStyle"));
    i0.ɵɵattribute("data-pc-section", "icon")("aria-hidden", true)("tabindex", -1);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-section", "label");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getItemLabel(processedItem_r1), " ");
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 13);
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r1.getItemLabel(processedItem_r1), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("data-pc-section", "label");
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.getItemProp(processedItem_r1, "badgeStyleClass"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getItemProp(processedItem_r1, "badge"));
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "AngleDownIcon", 16);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-submenu-icon");
    i0.ɵɵattribute("data-pc-section", "submenuicon")("aria-hidden", true);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "AngleRightIcon", 16);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-submenu-icon");
    i0.ɵɵattribute("data-pc-section", "submenuicon")("aria-hidden", true);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_Conditional_0_Conditional_0_Template, 1, 3, "AngleDownIcon", 16);
    i0.ɵɵconditionalCreate(1, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_Conditional_0_Conditional_1_Template, 1, 3, "AngleRightIcon", 16);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵconditional(ctx_r1.root ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.root ? 1 : -1);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_1_ng_template_0_Template(rf, ctx) {}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_1_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    i0.ɵɵproperty("data-pc-section", "submenuicon");
    i0.ɵɵariaProperty("aria-hidden", true);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_Conditional_0_Template, 2, 2);
    i0.ɵɵtemplate(1, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_1_Template, 1, 2, null, 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵconditional(!ctx_r1.submenuIconTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.submenuIconTemplate);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵconditionalCreate(1, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_1_Template, 1, 5, "span", 11);
    i0.ɵɵconditionalCreate(2, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_2_Template, 2, 2, "span", 12)(3, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_3_Template, 1, 2, "span", 13);
    i0.ɵɵconditionalCreate(4, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_4_Template, 2, 2, "span", 14);
    i0.ɵɵconditionalCreate(5, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Conditional_5_Template, 2, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("target", ctx_r1.getItemProp(processedItem_r1, "target"))("ngClass", i0.ɵɵpureFunction2(11, _c1, ctx_r1.getItemProp(processedItem_r1, "disabled"), ctx_r1.isItemActive(processedItem_r1)));
    i0.ɵɵattribute("href", ctx_r1.getItemProp(processedItem_r1, "url"), i0.ɵɵsanitizeUrl)("aria-hidden", true)("data-automationid", ctx_r1.getItemProp(processedItem_r1, "automationId"))("data-pc-section", "action")("tabindex", -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.getItemProp(processedItem_r1, "icon") ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.getItemProp(processedItem_r1, "escape") ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.getItemProp(processedItem_r1, "badge") ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isItemGroup(processedItem_r1) ? 5 : -1);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 11);
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.getItemProp(processedItem_r1, "icon"))("ngStyle", ctx_r1.getItemProp(processedItem_r1, "iconStyle"));
    i0.ɵɵattribute("data-pc-section", "icon")("aria-hidden", true)("tabindex", -1);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getItemLabel(processedItem_r1));
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 13);
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r1.getItemLabel(processedItem_r1), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("data-pc-section", "label");
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.getItemProp(processedItem_r1, "badgeStyleClass"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getItemProp(processedItem_r1, "badge"));
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "AngleDownIcon", 16);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-submenu-icon");
    i0.ɵɵattribute("data-pc-section", "submenuicon")("aria-hidden", true);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "AngleRightIcon", 16);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-submenu-icon");
    i0.ɵɵattribute("data-pc-section", "submenuicon")("aria-hidden", true);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_Conditional_0_Conditional_0_Template, 1, 3, "AngleDownIcon", 16);
    i0.ɵɵconditionalCreate(1, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_Conditional_0_Conditional_1_Template, 1, 3, "AngleRightIcon", 16);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵconditional(ctx_r1.root ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.root ? 1 : -1);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_1_ng_template_0_Template(rf, ctx) {}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_1_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    i0.ɵɵproperty("data-pc-section", "submenuicon");
    i0.ɵɵariaProperty("aria-hidden", true);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_Conditional_0_Template, 2, 2);
    i0.ɵɵtemplate(1, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_1_Template, 1, 2, null, 15);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(5);
    const menubar_r4 = i0.ɵɵreference(1);
    i0.ɵɵconditional(!menubar_r4.submenuIconTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", menubar_r4.submenuIconTemplate);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵconditionalCreate(1, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_1_Template, 1, 5, "span", 11);
    i0.ɵɵconditionalCreate(2, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_2_Template, 2, 1, "span", 12)(3, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_3_Template, 1, 2, "span", 13);
    i0.ɵɵconditionalCreate(4, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_4_Template, 2, 2, "span", 14);
    i0.ɵɵconditionalCreate(5, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Conditional_5_Template, 2, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r1.getItemProp(processedItem_r1, "routerLink"))("queryParams", ctx_r1.getItemProp(processedItem_r1, "queryParams"))("routerLinkActivePath", i0.ɵɵpureFunction0(19, _c2))("target", ctx_r1.getItemProp(processedItem_r1, "target"))("ngClass", i0.ɵɵpureFunction1(20, _c3, ctx_r1.getItemProp(processedItem_r1, "disabled")))("fragment", ctx_r1.getItemProp(processedItem_r1, "fragment"))("queryParamsHandling", ctx_r1.getItemProp(processedItem_r1, "queryParamsHandling"))("preserveFragment", ctx_r1.getItemProp(processedItem_r1, "preserveFragment"))("skipLocationChange", ctx_r1.getItemProp(processedItem_r1, "skipLocationChange"))("replaceUrl", ctx_r1.getItemProp(processedItem_r1, "replaceUrl"))("state", ctx_r1.getItemProp(processedItem_r1, "state"));
    i0.ɵɵattribute("data-automationid", ctx_r1.getItemProp(processedItem_r1, "automationId"))("tabindex", -1)("aria-hidden", true)("data-pc-section", "action");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.getItemProp(processedItem_r1, "icon") ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.getItemProp(processedItem_r1, "escape") ? 2 : 3);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.getItemProp(processedItem_r1, "badge") ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isItemGroup(processedItem_r1) ? 5 : -1);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_0_Template, 6, 14, "a", 9);
    i0.ɵɵconditionalCreate(1, MenubarSub_For_3_Conditional_1_Conditional_3_Conditional_1_Template, 6, 22, "a", 10);
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r1.getItemProp(processedItem_r1, "routerLink") ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.getItemProp(processedItem_r1, "routerLink") ? 1 : -1);
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_4_0_ng_template_0_Template(rf, ctx) {}
function MenubarSub_For_3_Conditional_1_Conditional_4_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MenubarSub_For_3_Conditional_1_Conditional_4_0_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MenubarSub_For_3_Conditional_1_Conditional_4_0_Template, 1, 0, null, 18);
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c4, processedItem_r1.item));
  }
}
function MenubarSub_For_3_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-menubarSub", 19);
    i0.ɵɵlistener("itemClick", function MenubarSub_For_3_Conditional_1_Conditional_5_Template_p_menubarSub_itemClick_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.itemClick.emit($event));
    })("itemMouseEnter", function MenubarSub_For_3_Conditional_1_Conditional_5_Template_p_menubarSub_itemMouseEnter_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onItemMouseEnter($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const processedItem_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("itemTemplate", ctx_r1.itemTemplate)("items", processedItem_r1.items)("mobileActive", ctx_r1.mobileActive)("autoDisplay", ctx_r1.autoDisplay)("menuId", ctx_r1.menuId)("activeItemPath", ctx_r1.activeItemPath)("focusedItemId", ctx_r1.focusedItemId)("level", ctx_r1.level + 1);
  }
}
function MenubarSub_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 6, 1)(2, "div", 7);
    i0.ɵɵlistener("click", function MenubarSub_For_3_Conditional_1_Template_div_click_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const processedItem_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onItemClick($event, processedItem_r1));
    })("mouseenter", function MenubarSub_For_3_Conditional_1_Template_div_mouseenter_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const processedItem_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onItemMouseEnter({
        $event: $event,
        processedItem: processedItem_r1
      }));
    });
    i0.ɵɵconditionalCreate(3, MenubarSub_For_3_Conditional_1_Conditional_3_Template, 2, 2);
    i0.ɵɵconditionalCreate(4, MenubarSub_For_3_Conditional_1_Conditional_4_Template, 1, 4);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(5, MenubarSub_For_3_Conditional_1_Conditional_5_Template, 1, 8, "p-menubarSub", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const processedItem_r1 = ctx_r5.$implicit;
    const ɵ$index_3_r7 = ctx_r5.$index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.getItemProp(processedItem_r1, "styleClass"));
    i0.ɵɵproperty("ngStyle", ctx_r1.getItemProp(processedItem_r1, "style"))("ngClass", ctx_r1.getItemClass(processedItem_r1));
    i0.ɵɵattribute("id", ctx_r1.getItemId(processedItem_r1))("data-pc-section", "menuitem")("data-p-highlight", ctx_r1.isItemActive(processedItem_r1))("data-p-focused", ctx_r1.isItemFocused(processedItem_r1))("data-p-disabled", ctx_r1.isItemDisabled(processedItem_r1))("aria-label", ctx_r1.getItemLabel(processedItem_r1))("aria-disabled", ctx_r1.isItemDisabled(processedItem_r1) || undefined)("aria-haspopup", ctx_r1.isItemGroup(processedItem_r1) && !ctx_r1.getItemProp(processedItem_r1, "to") ? "menu" : undefined)("aria-expanded", ctx_r1.isItemGroup(processedItem_r1) ? ctx_r1.isItemActive(processedItem_r1) : undefined)("aria-level", ctx_r1.level + 1)("aria-setsize", ctx_r1.getAriaSetSize())("aria-posinset", ctx_r1.getAriaPosInset(ɵ$index_3_r7));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("data-pc-section", "content");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.itemTemplate ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.itemTemplate ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isItemVisible(processedItem_r1) && ctx_r1.isItemGroup(processedItem_r1) ? 5 : -1);
  }
}
function MenubarSub_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MenubarSub_For_3_Conditional_0_Template, 1, 5, "li", 3);
    i0.ɵɵconditionalCreate(1, MenubarSub_For_3_Conditional_1_Template, 6, 20, "li", 4);
  }
  if (rf & 2) {
    const processedItem_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.isItemVisible(processedItem_r1) && ctx_r1.getItemProp(processedItem_r1, "separator") ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isItemVisible(processedItem_r1) && !ctx_r1.getItemProp(processedItem_r1, "separator") ? 1 : -1);
  }
}
const _c5 = ["*"];
const _c6 = a0 => ({
  "p-menubar p-component": true,
  "p-menubar-mobile-active": a0
});
function UiMenubarComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiMenubarComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, UiMenubarComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.startTemplate);
  }
}
function UiMenubarComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "BarsIcon");
  }
}
function UiMenubarComponent_Conditional_2_3_ng_template_0_Template(rf, ctx) {}
function UiMenubarComponent_Conditional_2_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiMenubarComponent_Conditional_2_3_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiMenubarComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 8, 1);
    i0.ɵɵlistener("click", function UiMenubarComponent_Conditional_2_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.menuButtonClick($event));
    })("keydown", function UiMenubarComponent_Conditional_2_Template_a_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.menuButtonKeydown($event));
    });
    i0.ɵɵconditionalCreate(2, UiMenubarComponent_Conditional_2_Conditional_2_Template, 1, 0, "BarsIcon");
    i0.ɵɵtemplate(3, UiMenubarComponent_Conditional_2_3_Template, 1, 0, null, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-haspopup", ctx_r0.model.length && ctx_r0.model.length > 0 ? true : false)("aria-expanded", ctx_r0.mobileActive)("aria-controls", ctx_r0.id)("aria-label", ctx_r0.config.translation.aria.navigation)("data-pc-section", "button");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.menuIconTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.menuIconTemplate);
  }
}
function UiMenubarComponent_Conditional_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiMenubarComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, UiMenubarComponent_Conditional_5_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.endTemplate);
  }
}
function UiMenubarComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
const _c7 = "@layer primeng{.p-menubar{display:flex;align-items:center}.p-menubar ul{margin:0;padding:0;list-style:none}.p-menubar .p-menuitem-link{cursor:pointer;display:flex;align-items:center;text-decoration:none;overflow:hidden;position:relative}.p-menubar .p-menuitem-text{line-height:1}.p-menubar .p-menuitem{position:relative}.p-menubar-root-list{display:flex;align-items:center;flex-wrap:wrap}.p-menubar-root-list>li ul{display:none;z-index:1}.p-menubar-root-list>.p-menuitem-active>p-menubarsub>.p-submenu-list{display:block}.p-menubar .p-submenu-list{display:none;position:absolute;z-index:2}.p-menubar .p-submenu-list>.p-menuitem-active>p-menubarsub>.p-submenu-list{display:block;left:100%;top:0}.p-menubar .p-submenu-list .p-menuitem-link .p-submenu-icon:not(svg){margin-left:auto}.p-menubar .p-menubar-root-list .p-icon-wrapper,.p-menubar .p-submenu-list .p-menuitem-link .p-icon-wrapper{margin-left:auto}.p-menubar .p-menubar-custom,.p-menubar .p-menubar-end{margin-left:auto;align-self:center}.p-menubar-button{display:none;cursor:pointer;align-items:center;justify-content:center}}.p-menubar{padding:0;background-color:var(--menuBgColor);border:0;border-color:var(--menuBorderColor)}.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link{padding:10px 12px}.p-submenu-list{padding:1px 0;background-color:var(--menuBgColor);border:1px solid #c8c8c8;border-color:var(--overlayMenuBorderColor);box-shadow:0 0 6px #00000029}.p-menuitem{margin:0}.p-menuitem .p-menuitem-text{line-height:1.3}.p-menuitem .p-menuitem-link .p-submenu-icon{right:6px}.p-menuitem .p-menuitem-link.p-menuitem-link-active{background-color:var(--menuitemActiveBgColor)}.p-menuitem .p-menuitem-link.p-menuitem-link-active .p-menuitem-text{color:var(--menuitemActiveTextColor)}.p-menuitem .p-menuitem-link.p-menuitem-link-active .p-menuitem-icon{color:var(--menuitemActiveIconColor)}body.a11y-no-distraction-mode .p-menubar .p-menuitem-icon{display:none}\n";
export let MenubarSub = /*#__PURE__*/(() => {
  class MenubarSub extends MenubarSubBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMenubarSub_BaseFactory;
        return function MenubarSub_Factory(__ngFactoryType__) {
          return (ɵMenubarSub_BaseFactory || (ɵMenubarSub_BaseFactory = i0.ɵɵgetInheritedFactory(MenubarSub)))(__ngFactoryType__ || MenubarSub);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MenubarSub,
        selectors: [["p-menubarSub"]],
        hostAttrs: [1, "p-element"],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 10,
        consts: [["menubar", ""], ["listItem", ""], ["role", "menubar", 3, "focus", "blur", "keydown", "ngClass", "tabindex"], ["role", "separator", 3, "style", "ngClass"], ["role", "menuitem", 3, "ngStyle", "ngClass", "class"], ["role", "separator", 3, "ngClass"], ["role", "menuitem", 3, "ngStyle", "ngClass"], [1, "p-menuitem-content", 3, "click", "mouseenter"], [3, "itemTemplate", "items", "mobileActive", "autoDisplay", "menuId", "activeItemPath", "focusedItemId", "level"], ["pRipple", "", 3, "target", "ngClass"], ["pRipple", "", 3, "routerLink", "queryParams", "routerLinkActivePath", "target", "ngClass", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state"], [1, "p-menuitem-icon", 3, "ngClass", "ngStyle"], [1, "p-menuitem-text"], [1, "p-menuitem-text", 3, "innerHTML"], [1, "p-menuitem-badge", 3, "ngClass"], [4, "ngTemplateOutlet"], [3, "styleClass"], [3, "data-pc-section", "aria-hidden"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "itemClick", "itemMouseEnter", "itemTemplate", "items", "mobileActive", "autoDisplay", "menuId", "activeItemPath", "focusedItemId", "level"]],
        template: function MenubarSub_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ul", 2, 0);
            i0.ɵɵlistener("focus", function MenubarSub_Template_ul_focus_0_listener($event) {
              return ctx.menuFocus.emit($event);
            })("blur", function MenubarSub_Template_ul_blur_0_listener($event) {
              return ctx.menuBlur.emit($event);
            })("keydown", function MenubarSub_Template_ul_keydown_0_listener($event) {
              return ctx.menuKeydown.emit($event);
            });
            i0.ɵɵrepeaterCreate(2, MenubarSub_For_3_Template, 2, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0, !ctx.root, ctx.root))("tabindex", 0);
            i0.ɵɵattribute("data-pc-section", "menu")("aria-label", ctx.ariaLabel)("aria-labelledBy", ctx.ariaLabelledBy)("id", ctx.menuId)("aria-activedescendant", ctx.focusedItemId);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.items);
          }
        },
        dependencies: [MenubarSub, CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle, RouterModule, i2.RouterLink, AngleDownIcon, AngleRightIcon, UiRouterLinkActivePathDirective],
        styles: [_c7],
        encapsulation: 2
      });
    }
  }
  return MenubarSub;
})();
export let UiMenubarComponent = /*#__PURE__*/(() => {
  class UiMenubarComponent extends MenubarBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUiMenubarComponent_BaseFactory;
        return function UiMenubarComponent_Factory(__ngFactoryType__) {
          return (ɵUiMenubarComponent_BaseFactory || (ɵUiMenubarComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UiMenubarComponent)))(__ngFactoryType__ || UiMenubarComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiMenubarComponent,
        selectors: [["ui-menubar"]],
        hostAttrs: [1, "p-element"],
        features: [i0.ɵɵProvidersFeature([MenubarService]), i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c5,
        decls: 7,
        vars: 24,
        consts: [["rootmenu", ""], ["menubutton", ""], [3, "ngClass", "ngStyle"], [1, "p-menubar-start"], ["tabindex", "0", "role", "button", 1, "p-menubar-button"], [3, "itemClick", "menuFocus", "menuBlur", "menuKeydown", "itemMouseEnter", "items", "itemTemplate", "menuId", "root", "baseZIndex", "autoZIndex", "mobileActive", "autoDisplay", "ariaLabel", "ariaLabelledBy", "focusedItemId", "submenuIconTemplate", "activeItemPath"], [1, "p-menubar-end"], [4, "ngTemplateOutlet"], ["tabindex", "0", "role", "button", 1, "p-menubar-button", 3, "click", "keydown"]],
        template: function UiMenubarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵconditionalCreate(1, UiMenubarComponent_Conditional_1_Template, 2, 1, "div", 3);
            i0.ɵɵconditionalCreate(2, UiMenubarComponent_Conditional_2_Template, 4, 7, "a", 4);
            i0.ɵɵelementStart(3, "p-menubarSub", 5, 0);
            i0.ɵɵlistener("itemClick", function UiMenubarComponent_Template_p_menubarSub_itemClick_3_listener($event) {
              return ctx.onItemClick($event);
            })("menuFocus", function UiMenubarComponent_Template_p_menubarSub_menuFocus_3_listener($event) {
              return ctx.onMenuFocus($event);
            })("menuBlur", function UiMenubarComponent_Template_p_menubarSub_menuBlur_3_listener($event) {
              return ctx.onMenuBlur($event);
            })("menuKeydown", function UiMenubarComponent_Template_p_menubarSub_menuKeydown_3_listener($event) {
              return ctx.onKeyDown($event);
            })("itemMouseEnter", function UiMenubarComponent_Template_p_menubarSub_itemMouseEnter_3_listener($event) {
              return ctx.onItemMouseEnter($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(5, UiMenubarComponent_Conditional_5_Template, 2, 1, "div", 6)(6, UiMenubarComponent_Conditional_6_Template, 2, 0, "div", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.styleClass);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c6, ctx.mobileActive))("ngStyle", ctx.style);
            i0.ɵɵattribute("data-pc-section", "root")("data-pc-name", "menubar");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.startTemplate ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.model && ctx.model.length > 0 ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("items", ctx.processedItems)("itemTemplate", ctx.itemTemplate)("menuId", ctx.id)("root", true)("baseZIndex", ctx.baseZIndex)("autoZIndex", ctx.autoZIndex)("mobileActive", ctx.mobileActive)("autoDisplay", ctx.autoDisplay)("ariaLabel", ctx.ariaLabel)("ariaLabelledBy", ctx.ariaLabelledBy)("focusedItemId", ctx.focused ? ctx.focusedItemId : undefined)("submenuIconTemplate", ctx.submenuIconTemplate)("activeItemPath", ctx.activeItemPath());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.endTemplate ? 5 : 6);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle, RouterModule, BarsIcon, MenubarSub],
        styles: [_c7],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return UiMenubarComponent;
})();